import { render, staticRenderFns } from "./SetFlags.vue?vue&type=template&id=69a1dd9e&scoped=true&"
import script from "./SetFlags.vue?vue&type=script&lang=ts&"
export * from "./SetFlags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a1dd9e",
  null
  
)

export default component.exports